import React from "react";
import cx from "classnames";
import { Container } from "src/components/container";
import { BlockContent } from "src/components/block-content";

import { useInView } from "react-intersection-observer";

import * as styles from "./intro.module.css";

export interface EMEAIntroData {
	introCopy: any[];
}

export const EMEAIntro = ({ data }: { data: EMEAIntroData }) => {
	const { introCopy } = data;
	const { ref, inView } = useInView({
		threshold: 0.5,
	});

	return (
		<div className={styles.intro} ref={ref}>
			<Container>
				<BlockContent
					className={cx("ac title highlight-em", inView ? "in-view" : "")}
					blocks={introCopy}
				/>
			</Container>
		</div>
	);
};
